"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileFiltersModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dialog_1 = require("primereact/dialog");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const FilterPanel_1 = require("./FilterPanel");
const MobileFiltersModal = ({ visible, onHide, filters, values, onFilterChange, activeCount = 0, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [localValues, setLocalValues] = (0, react_1.useState)(values);
    (0, react_1.useEffect)(() => {
        if (visible)
            setLocalValues(values);
    }, [visible]);
    (0, react_1.useEffect)(() => {
        if (visible) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [visible]);
    const resolvedFilters = typeof filters === 'function' ? filters(localValues) : filters;
    const handleApply = () => {
        onFilterChange(localValues);
        onHide();
    };
    const handleClear = () => {
        const cleared = Object.fromEntries(resolvedFilters.map((f) => [f.key, []]));
        setLocalValues(cleared);
        onFilterChange(cleared);
        onHide();
    };
    return ((0, jsx_runtime_1.jsxs)(dialog_1.Dialog, { visible: visible, position: "bottom", onHide: onHide, showHeader: false, dismissableMask: true, className: "w-full m-0 rounded-t-2xl animate-slide-up", contentClassName: "rounded-t-2xl p-4 bg-white", maskClassName: "backdrop-blur-xs bg-black/30 animate-fade-in", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4 mt-2" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between mb-4", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-lg font-semibold text-gray-900", children: t('filter') }), activeCount > 0 && ((0, jsx_runtime_1.jsxs)("span", { className: "bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-1 rounded-full", children: [activeCount, " ", activeCount === 1 ? t('active') : t('active')] }))] }), (0, jsx_runtime_1.jsx)(FilterPanel_1.FilterPanel, { filters: resolvedFilters, localValues: localValues, onChange: (key, val) => setLocalValues((prev) => ({ ...prev, [key]: val })), onApply: handleApply, onClear: handleClear })] }));
};
exports.MobileFiltersModal = MobileFiltersModal;
